import { z } from 'zod';

import { PostfixCriteriaSchema } from '../postfixCriteria';
import { PostfixFunctionSchema } from '../postfixLogic';

import { ApiTagRequestTypeSchema } from './tagRequestTypes';

export const ApiSourceOfTruthQualifierSchema = z.object({
  name: z.string(),
  id: z.string(),
  defaultForAll: z.boolean().optional(),
  qualifier: PostfixFunctionSchema.optional().nullable(),
  postfix: PostfixCriteriaSchema.optional().nullable(),
});

type ApiSourceOfTruthQualifier = z.infer<typeof ApiSourceOfTruthQualifierSchema>;

export const ApiQualifierResponseSchema = z.object({
  qualifiers: z.array(ApiSourceOfTruthQualifierSchema),
  tagRequestTypes: z.array(ApiTagRequestTypeSchema),
  qualifierRuleUsages: z.record(z.string(), z.array(z.string())),
});

export type ApiQualifierResponse = z.infer<typeof ApiQualifierResponseSchema>;

export default ApiSourceOfTruthQualifier;
